import { Api } from '../api';
import { ICreateOrganization, IOrganization, IResponseOrganization } from 'shared/types';



const getOrganizations = async (): Promise<IOrganization[] | Error> => {
  try {
    const { data } = await Api.get('/Orgs/perfil');

    if (data) {
      return data;
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IOrganization | Error> => {
  try {
    const { data } = await Api.get(`/Orgs/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};
//teste nova endpoint
const getAll = async (filter = ''): Promise<IResponseOrganization | Error> => {
  try{
    const { data, status } = await Api.get(`/Orgs/${filter !== '' ? '?' : ''}${filter}`);

    if (data) {
      return data;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const create = async (dados: ICreateOrganization): Promise<string | Error> => {
  try {
    const { data, status } = await Api.post('/Orgs', dados);
    if (data) {
      const { erro } = data;
      if (erro) {
        return new Error(`${erro.mensagem} - ${erro.descricao}`);
      }
      if (status > 299) {
        return new Error(data);
      }
      return data.codigoOrganizacao;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao criar o registro.');
  }
};

const updateById = async (id: string, dados: ICreateOrganization,): Promise<void | Error> => {
  try {
    const { data, status } = await Api.put(`/Orgs/${id}`, dados);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao atualizar o registro.');
  }
};


const deleteById = async (id: string): Promise<void | Error> => {
  try {
    const { data, status } = await Api.delete(`/Orgs/${id}`);
    const { erro } = data;
    if (erro) {
      return new Error(`${erro.mensagem} - ${erro.descricao} - ${JSON.stringify(erro.restricoes)}`);
    }
    if (status > 299) {
      return new Error(data);
    }
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao apagar o registro.');
  }
};

export const OrganizationsService = {
  getOrganizations,
  getById,
  getAll,
  create,
  updateById,
  deleteById,
};
